export const isDraftLink = (path: string) => {
  return path.startsWith('/draft/');
};
